<form [formGroup]="datePickerForm">
  <mat-form-field
    *ngIf="inputViews === 'web'"
    class="example-full-width datePicker"
    appearance="fill"
  >
    <mat-label>{{ pickerPlaceholder }}</mat-label>
    <input
      matInput
      required
      [matDatepickerFilter]="myFilter"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      formControlName="selectedValue"
      (ngModelChange)="valueChanged()"
      readonly
      (click)="picker.open()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-form-field
    *ngIf="inputViews === 'mobile'"
    class="example-full-width"
    appearance="fill"
  >
    <mat-label>{{ pickerPlaceholder }}</mat-label>
    <input
      matInput
      required
      [matDatepickerFilter]="myFilter"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      formControlName="selectedValue"
      (ngModelChange)="valueChanged()"
      readonly
      (click)="picker.open()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <span class="posabs" style="line-height: 15px; color: deeppink">{{
    validateDate()
  }}</span>
</form>
